;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const TourCategory = {
	automations: "automations",
	dataIntegrations: "dataIntegrations",
	leaderboard: "leaderboard",
	sharing: "sharing",
	workspaceTeam: "workspaceTeam",
} as const;

export type TourCategory = (typeof TourCategory)[keyof typeof TourCategory];

export const TOUR_CATEGORY_LABELS: Record<TourCategory, string> = {
	[TourCategory.dataIntegrations]: "Data & Integrations",
	[TourCategory.workspaceTeam]: "Workspace & Team",
	[TourCategory.automations]: "Automations",
	[TourCategory.sharing]: "Sharing",
	[TourCategory.leaderboard]: "Leaderboard",
};

export const TOUR_CATEGORY_ORDER: TourCategory[] = [
	TourCategory.dataIntegrations,
	TourCategory.workspaceTeam,
	TourCategory.automations,
	TourCategory.sharing,
	TourCategory.leaderboard,
];
